export default __webpack_public_path__ + "static/media/05-wai.7d31e4cc.mp4";